module.exports = __webpack_public_path__ + "static/media/72.25d5dbd2.svg";